import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VoidPaymentListComponent } from './void-payment-list/void-payment-list.component';
import { VoidPaymentComponent } from './void-payment.component';

const routes: Routes = [
  {
    path: '',
    component: VoidPaymentComponent,
    children: [
      {
        path: '',
        component: VoidPaymentListComponent,
        data: {
          title: 'Lista de Pagos',
          id: 'VoidPaymentListComponent_voidPayment'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VoidPaymentRoutingModule { }
